import { Config } from '@/config';
import { Sentry } from '@/plugins/sentry';
import { ApiService } from '@/services/api.service';
import { StorageService } from '@/services/storage.service';
import axios from 'axios';

const CancelToken = axios.CancelToken;
let cancelToken = null;

export const UserService = {
  updatePassword(passwords, id) {
    return ApiService.post(`${Config.api.auth.url}users/${id}/change-password`, passwords)
      .then((response) => response.data)
      .then(({ user, token }) => {
        StorageService.saveToken(token);
        StorageService.saveCurrentUser(user);
        ApiService.setHeader();
        Sentry.setUser(user);

        return { user, token };
      });
  },

  patchUser(id, user) {
    if (cancelToken) {
      cancelToken.cancel('Multiple requests.');
    }
    cancelToken = CancelToken.source();

    return ApiService.patch(`${Config.api.auth.url}users/${id}`, user, { cancelToken: cancelToken.token })
      .then((response) => response.data)
      .then((user) => {
        StorageService.saveCurrentUser(user);
        Sentry.setUser(user);

        return user;
      });
  },

  deleteUser(id) {
    return ApiService.delete(`${Config.api.auth.url}users/${id}`)
      .then((response) => response.data)
      .catch((error) => {
        const status = error.response && error.response.status;
        const data = error.response && error.response.data;
        throw { status, data };
      });
  },

  // Admin-only edit of another user's role via the dedicated endpoint. Distinct
  // from `patchUser`, which persists the response into the current user's storage
  // (that one is for "me editing my own profile" only). Preserves HTTP status on
  // the thrown error so callers can surface a 403/404 inline if the FE-side rules
  // ever drift from the backend.
  updateUserRole(id, role) {
    return ApiService.put(`${Config.api.auth.url}users/${id}/role`, { role })
      .then((response) => response.data)
      .catch((error) => {
        const status = error.response && error.response.status;
        const data = error.response && error.response.data;
        throw { status, data };
      });
  },

  // Grants (PUT) or revokes (DELETE) one permission; both are idempotent and return the user with
  // their permissions in effect. Same error shape as `updateUserRole`.
  setUserPermission(id, permissionId, granted) {
    const url = `${Config.api.auth.url}users/${id}/permissions/${encodeURIComponent(permissionId)}`;
    const request = granted ? ApiService.put(url) : ApiService.delete(url);
    return request
      .then((response) => response.data)
      .catch((error) => {
        const status = error.response && error.response.status;
        const data = error.response && error.response.data;
        throw { status, data };
      });
  },
};
